//@flow
import type { AuthResultEvent } from './AuthResultEvent';
import { AuthRealm } from './AuthMechanism';
import { relativeTimeThreshold } from 'moment';
const debug = require('../debug/debug')('wc:auth:AbstractAuthType');

export interface AuthType {
  login(): Promise<AuthResultEvent>;

  getAuthRealm(): AuthRealm;

  abort(): void;
}

export default class AbstractAuthType implements AuthType {
  /**
   * @private
   * @type {AuthRealm}
   * @memberof AbstractAuthType
   */
  _authRealm: AuthRealm;

  constructor(authRealm: AuthRealm) {
    this._authRealm = authRealm;
    if (debug.enabled) {
      debug('[new AbstractAuthType(realmName=%o)] constructed.', authRealm);
    }
  }

  getAuthRealm(): AuthRealm {
    return this._authRealm;
  }

  login(): Promise<AuthResultEvent> {
    throw new Error('Abstract method called.');
  }

  abort(): void {
    throw new Error('Abstract method called.');
  }
}
